import React, { useCallback, useRef, useState } from 'react';
import { MoveHorizontalIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
interface BeforeAfterSliderProps {
  before: string;
  after: string;
  beforeAlt: string;
  afterAlt: string;
  className?: string;
}
export function BeforeAfterSlider({
  before,
  after,
  beforeAlt,
  afterAlt,
  className = ''
}: BeforeAfterSliderProps) {
  const {
    t
  } = useLanguage();
  const [position, setPosition] = useState(50);
  const containerRef = useRef<HTMLDivElement>(null);
  const dragging = useRef(false);
  const updateFromClientX = useCallback((clientX: number) => {
    const rect = containerRef.current?.getBoundingClientRect();
    if (!rect) return;
    const next = (clientX - rect.left) / rect.width * 100;
    setPosition(Math.min(100, Math.max(0, next)));
  }, []);
  const onPointerDown = (event: React.PointerEvent) => {
    dragging.current = true;
    event.currentTarget.setPointerCapture(event.pointerId);
    updateFromClientX(event.clientX);
  };
  const onPointerMove = (event: React.PointerEvent) => {
    if (!dragging.current) return;
    updateFromClientX(event.clientX);
  };
  const onPointerUp = (event: React.PointerEvent) => {
    dragging.current = false;
    event.currentTarget.releasePointerCapture(event.pointerId);
  };
  return <div ref={containerRef} className={`relative select-none overflow-hidden bg-navy-dark ${className}`} onPointerDown={onPointerDown} onPointerMove={onPointerMove} onPointerUp={onPointerUp} onPointerCancel={onPointerUp} data-id="element-17" data-mp="1nb0kro57uwfq">
      <img src={after} alt={afterAlt} loading="lazy" className="h-full w-full object-cover" data-id="element-18" data-mp="1wd9tc8gxcfqh" />
      <div className="absolute inset-0 overflow-hidden" style={{
      clipPath: `inset(0 ${100 - position}% 0 0)`
    }} aria-hidden="true" data-id="element-19" data-mp="218p955yhslpj">
        <img src={before} alt="" className="h-full w-full object-cover" data-id="element-20" data-mp="6xsidtjj3ele" />
      </div>
      <img src={before} alt={beforeAlt} className="sr-only" data-id="element-21" data-mp="bwn0et9o8z4g" />

      <span className="pointer-events-none absolute left-3 top-3 rounded bg-navy-deep/85 px-2.5 py-1 text-[0.7rem] font-bold uppercase tracking-wider text-white" data-id="element-22" data-mp="3uw4ed0ijgps">
        {t('projects.before')}
      </span>
      <span className="pointer-events-none absolute right-3 top-3 rounded bg-brand-700 px-2.5 py-1 text-[0.7rem] font-bold uppercase tracking-wider text-white" data-id="element-23" data-mp="dssjth0hgxtp">
        {t('projects.after')}
      </span>

      <div className="pointer-events-none absolute inset-y-0 w-0.5 bg-white" style={{
      left: `${position}%`
    }} aria-hidden="true" data-id="element-24" data-mp="mt8h28qmv8q4" />

      <input type="range" min={0} max={100} step={1} value={Math.round(position)} onChange={event => setPosition(Number(event.target.value))} aria-label={t('projects.slider')} className="absolute inset-x-0 bottom-0 h-full w-full cursor-ew-resize opacity-0" data-id="element-25" data-mp="iq2ebb2qbzoe" />

      <span className="pointer-events-none absolute top-1/2 z-10 flex h-10 w-10 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full bg-white text-navy shadow-lg" style={{
      left: `${position}%`
    }} aria-hidden="true" data-id="element-26" data-mp="11iwgt5j61zbq">
        <MoveHorizontalIcon className="h-5 w-5" data-id="element-27" data-mp="1p3p3s97yrjck" />
      </span>
    </div>;
}